{
    "85zkGNTIYziOiMQT-cGn5": {
        "tag": "spawngood",
        "key": "85zkGNTIYziOiMQT-cGn5",
        "position": {
            "x": 3,
            "y": 2,
            "z": 1
        }
    },
    "RGIV3MxJcSHhbVnmHW2a3": {
        "tag": "spawngood",
        "key": "RGIV3MxJcSHhbVnmHW2a3",
        "position": {
            "x": 3,
            "y": 6,
            "z": 1
        }
    },
    "BRN-0OmtBQWwLzAi5yUKV": {
        "tag": "spawngood",
        "key": "BRN-0OmtBQWwLzAi5yUKV",
        "position": {
            "x": 2,
            "y": 6,
            "z": 1
        }
    }
}
